<template>
    <div class="m-combat-rank"  v-if="combatRankingList">
        <div class="m-wrap ta-center"  style="margin-bottom:0; padding-bottom:0;">
            <h3 class="tb-title ">竞猜英雄榜</h3>
            <p class="t-box ta-center fts-24">
                <!--各路英雄豪杰下注排名榜单-->
                竞猜日期：{{updateTime}}
            </p>
            <div class="table-body">
                <div style="padding:0 .2rem; background:#fdb774;">
                    <table class="m-table top-radius">
                        <thead>
                        <tr>
                            <th width="12%">排名</th>
                            <th width="45%">昵称</th>
                            <!--<th width="14%">时间</th>-->
                            <th width="14%">投注</th>
                            <th>投注数额</th>
                        </tr>
                        </thead>
                    </table>
                </div>
                
                <div class="table-body--bd" v-if="combatRankingList.rankList" :style="{maxHeight:boxHeight?'initial':'6rem'}">
                    <table class="m-table">
                        <tbody>
                        <tr v-for="(item,index) in combatRankingList.rankList" :key="index">
                            <td width="12%"><span class="cl-666" :class="rankClass(index)">{{index>2?(index+1):''}}</span></td>
                            <td width="45%" class="ta-left">
                                <router-link :to="{name:'others',query:{uid:item.userInfo['uid']}}" >
                                    <k-user :logo="item.userInfo.logo.thumb50" :nick="item.userInfo.nick"></k-user>
                                </router-link>
                            </td>
                            <!--<td width="14%" class="grayColor fts-28">{{item.transDate.slice(8,10)}}日</td>-->
                            <td width="14%" class="fts-28">
                                <k-text :type="item.betType"></k-text>
                            </td>
                            <td class="ta-right cl-org fts-28" style="padding-right:0;"><k-num :value="item.betNum*100" /> <span class="icon-gold"></span></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="combatRankingList.rankList && combatRankingList.rankList.length===0" class="no-data">
                    <k-no-data></k-no-data>
                </div>
            </div>
            <div>
                <a href="javascript:;" class="btn-slide" type="default"  @click="boxHeight=!boxHeight"><van-icon v-if="boxHeight" name="arrow-up" /> <van-icon v-else name="arrow-down" /></a>
            </div>
            <div class="table-body" v-if="combatRankingList.myBetInfo && combatRankingList.myBetInfo.rank>10">
                <table class="m-table">            
                    <tbody>
                        <tr>
                            <td width="12%" class="table-td-12">{{ combatRankingList.myBetInfo.rank}}</td>
                            <td width="46%" class="ta-left pd-2">
                                <k-user :logo="myLogo" :nick="myNick"></k-user>
                            </td>
                            <!--<td width="14%" class="grayColor fts-28">{{ combatRankingList.myBetInfo.transDate.slice(8,10)}}日</td>-->
                            <td width="14%" class="fts-28">
                                <k-text :type="combatRankingList.myBetInfo.betType"></k-text>
                            </td>
                            <td class="ta-right cl-org  fts-28"><k-num :value="combatRankingList.myBetInfo.betNum*100 " /> <span class="icon-gold"></span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {getServerTime, dataFormat } from '../../../utils/base'
    export default {
        data() {
            return {
                boxHeight: false
            }
        },
        computed: {
            ...mapGetters(['myUid','myLogo','myNick']),
            ...mapGetters('home', ['transDate']),
            ...mapGetters('ranking', ['combatRankingList']),
            updateTime(){
                let tm = '';
                if(this.combatRankingList && this.combatRankingList.rankList.length){
                    tm = this.combatRankingList.rankList[0].transDate.slice(0,10)
                }
                return tm
            }
        },
        methods: {           
            ...mapActions('ranking', ['loadCombatRankingList','loadWeekRankingList']),
            rankClass(index){
                return index < 3 ? ('sort-' + index) : ''
            }
        },
        created() {
            this.loadCombatRankingList()
            //this.loadWeekRankingList()
        },
        watch: {
            combatRankingList(){

            }
        },
    }
</script>